import "./FileUploaderInputField.scss"
import React from 'react'
import { FileUpload } from 'primereact/fileupload';
import { ReactComponent as UploadIcon } from "./../../assets/recruitment/MDI - tray-arrow-up.svg"

const FileUploaderInputField = React.forwardRef(({ ...restProps }, ref) => {

  const chooseOptions = {
    icon: <UploadIcon className="p-button-icon-right UploadIcon" />,
    iconOnly: true,
    className: 'p-button-text'
  };

  return (
    <div className="FileUploaderInputField grid ">
      <div className="col p-0">
        <FileUpload
          ref={ref}
          mode="basic"
          chooseOptions={chooseOptions}
          {...restProps}
        />
      </div>
    </div>
  )
})

export default FileUploaderInputField